module.exports = __webpack_public_path__ + "img/container-dark-grey.5e954f00.svg";